function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from 'react';
import { makeStyles } from 'tss-react/mui';
import PropTypes from "prop-types";
import Paper from "@pixel/core/Paper";
import DragHandleIcon from "@pixel/assets/icons/DragIndicator"; //todo @pixel
import { useTheme } from '@pixel/core';
const containedBorderWidth = 1;
const useStyles = makeStyles({
  name: {
    DragContainer
  }
})((_theme, _ref) => {
  let {
    pixelTheme
  } = _ref;
  return {
    root: {
      cursor: "default",
      display: "block",
      borderBottom: "solid 1px " + pixelTheme.palette.divider,
      "&:focus, &:hover": {
        outline: "none"
      },
      "& $paper": {
        borderRadius: pixelTheme.shape.borderRadius * 1.25,
        transition: "border-left-color 0.2s ease"
      },
      "&:focus $paper": {
        marginLeft: 0,
        borderLeft: "solid " + pixelTheme.size.focusWidth + "px " + pixelTheme.palette.pixelContrast.fades.hard
      },
      "& $dragger": {
        padding: pixelTheme.spacing(0.25),
        transition: "color 0.2s ease"
      },
      "&:focus $dragger, &:hover $dragger": {
        color: pixelTheme.palette.pixelContrast.fades.hardest
      }
    },
    rootDraggging: {
      cursor: 'hand',
      "& $dragger": {
        color: pixelTheme.palette.pixelContrast.fades.hard
      },
      "& $paper": {
        borderColor: pixelTheme.palette.pixelContrast.fades.hard
      }
    },
    rootContained: {
      padding: pixelTheme.spacing(0.75, 0),
      borderBottom: "none"
      // "&:focus $paper": {
      //   marginLeft: 1,
      //   borderColor: pixelTheme.palette.primary.main,
      // },
    },
    paper: {
      display: 'flex',
      flex: 1,
      marginLeft: pixelTheme.size.focusWidth,
      marginRight: pixelTheme.size.focusWidth,
      padding: pixelTheme.spacing(1)
    },
    paperContained: {
      '&.$noSeperator': {
        marginBottom: "none",
        border: "none"
      }
    },
    noSeperator: {
      borderBottom: "none"
    },
    noPadding: {
      padding: 0
    },
    disabled: {
      "& $dragger": {
        cursor: "default",
        color: pixelTheme.palette.pixelContrast.fades.softer + " !important"
      }
    },
    paperDense: {
      padding: pixelTheme.spacing(0.125)
    },
    dragger: {
      display: 'flex',
      width: pixelTheme.spacing(4),
      alignItems: "center",
      color: pixelTheme.palette.pixelContrast.fades.medium
    },
    content: {
      flex: "1 0 10%",
      display: "flex",
      overflow: "hidden"
    },
    contentInner: {
      width: "100%",
      display: "flex"
    }
  };
});
function DragContainer(props) {
  const theme = useTheme();
  const {
    children,
    hideDragger,
    noSeperator,
    noPadding,
    dense,
    variant,
    disabled,
    dndProvided,
    dndSnapshot,
    ref,
    ...restProps
  } = props;
  const {
    classes
  } = useStyles({
    pixelTheme: theme
  });
  const isContained = variant == "contained";
  const rootClassA = [classes.root];
  const paperClassA = [classes.paper];
  if (noSeperator) {
    rootClassA.push(classes.noSeperator);
  }
  if (disabled) {
    rootClassA.push(classes.disabled);
  }
  if (noPadding) {
    if (!isContained) {
      rootClassA.push(classes.noPadding);
    }
    paperClassA.push(classes.noPadding);
  } else if (dense) {
    paperClassA.push(classes.paperDense);
  }
  if (isContained) {
    rootClassA.push(classes.rootContained);
    paperClassA.push(classes.paperContained);
  }
  if (dndSnapshot.isDragging) {
    rootClassA.push(classes.rootDraggging);
  }
  const elevationMain = isContained ? 2 : 0;
  const elevation = dndSnapshot.isDragging ? 5 : elevationMain;
  const mainRender = /*#__PURE__*/React.createElement("div", _extends({
    ref: dndProvided.innerRef
  }, dndProvided.draggableProps, dndProvided.dragHandleProps, {
    className: rootClassA.join(" "),
    style: dndProvided.draggableProps.style
  }, restProps), /*#__PURE__*/React.createElement(Paper, {
    elevation: elevation,
    square: !dndSnapshot.isDragging && !isContained
  }, /*#__PURE__*/React.createElement("div", {
    className: paperClassA.join(" ")
  }, !hideDragger && /*#__PURE__*/React.createElement("div", {
    className: classes.dragger
  }, /*#__PURE__*/React.createElement(DragHandleIcon, null)), /*#__PURE__*/React.createElement("div", {
    className: classes.content
  }, /*#__PURE__*/React.createElement("div", {
    className: classes.contentInner
  }, children)))));
  return mainRender;
}
DragContainer.propTypes = {
  dndProvided: PropTypes.object.isRequired,
  dndSnapshot: PropTypes.object.isRequired,
  variant: PropTypes.oneOf(['standard', 'contained']).isRequired,
  noSeperator: PropTypes.bool.isRequired,
  noPadding: PropTypes.bool.isRequired,
  dense: PropTypes.bool.isRequired,
  hideDragger: PropTypes.bool.isRequired,
  disabled: PropTypes.bool.isRequired
};
DragContainer.defaultProps = {
  variant: "standard",
  noSeperator: false,
  noPadding: false,
  dense: false,
  hideDragger: false,
  disabled: false
};
export default DragContainer;